module.exports = __webpack_public_path__ + "static/14-6112c312b1c80420d00ba039186cca17.jpg";